// extracted by mini-css-extract-plugin
module.exports = {"component":"modal_component__gCZRn","isCentered":"modal_isCentered__xrZ3u","backdropFadeIn":"modal_backdropFadeIn__JRIuS"};